import React from "react";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import whatsapp from "../../../assets/images/whatsapp.png";

export default function Connect(props) {
  const { handleMobileDetails, loanDetails } = props;

  const circleStyle = {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginLeft: "12px",
          alignItems: "flex-start",
          gap: "12px",
        }}
      >
        <a
          onClick={() => handleMobileDetails()}
          style={{
            ...circleStyle,
            background: "#c7ddf3ff",
            border: "2px solid #eff6ff",
          }}
        >
          <CallOutlinedIcon sx={{ color: "#1976d2" }} />
        </a>
        <a
          href={`https://wa.me/+91${loanDetails.mobile}`}
          target="_blank"
          rel="noreferrer"
     
          style={{
            ...circleStyle,
            backgroundColor: "#ecfdf5",
            border: "1px solid #d0fae5",
          }}
        >
          <img src={whatsapp} alt="wpImg" />
        </a>

        <a
          href={`mailto:${loanDetails.email}`}
          target="_blank"
          rel="noreferrer"
          style={{
            ...circleStyle,
            backgroundColor: "#FEEAEB",
            border: "1px solid #ffe2e2",
          }}
        >
          <MailOutlineOutlinedIcon sx={{ color: "#e7000b" }} />
        </a>
      </div>
    </div>
  );
}
